export const IS_PRODUCTION = process.env.NODE_ENV === 'production';
export const POSTHOG_ENABLED = IS_PRODUCTION || process.env.NEXT_PUBLIC_FORCE_ANALYTICS === 'true';

const RAW_DEPLOY_ENV = process.env.NEXT_PUBLIC_DEPLOY_ENV;
export const DEPLOY_ENV: 'development' | 'production' =
  RAW_DEPLOY_ENV === 'prod' || RAW_DEPLOY_ENV === 'production' ? 'production' : 'development';
export const IS_DEPLOY_PRODUCTION = DEPLOY_ENV === 'production';

export const POSTHOG_HOST = 'https://us.i.posthog.com';

export const BASE_URL = 'https://bazak.ai';
export const STATUS_PAGE_URL = 'https://status.bazak.ai';
export const PLATFORM_URL = 'https://os.bazak.ai';
// Same string today, but they name different things in structured data: the SoftwareApplication
// versus the Organization behind it. Keep them separate so a product rename cannot silently
// rename the company.
export const PRODUCT_NAME = 'Bazak';
export const COMPANY_NAME = 'Bazak';
export const SUPPORT_EMAIL = 'support@bazak.ai';
export const PRIVACY_EMAIL = 'privacy@bazak.ai';
export const HTTP_STATUS = { NOT_FOUND: 404 } as const;

export const DEMO_URL = 'https://calendar.app.google/mWmsY7uZ38ipdeXd7';

export const HUBSPOT_PORTAL_ID = '146410257';
// This portal lives in HubSpot's EU data center, which answers form submissions on its own
// host. The default api.hsforms.com returns 403 "Portal isn't allowed to post submissions".
export const HUBSPOT_FORMS_ORIGIN = 'https://api-eu1.hsforms.com';

export const LEGAL_LAST_UPDATED_ISO = '2026-05-08';
export const LEGAL_LAST_UPDATED_LABEL = 'May 8, 2026';

export const LEGAL_ROUTES = {
  privacyNotice: '/privacy-notice',
  cookieNotice: '/cookie-notice',
  doNotSell: '/do-not-sell',
  termsOfUse: '/terms-of-use',
} as const;

export const MARKETING_ROUTES = {
  home: '/',
  scan: '/scan',
  industries: '/industries',
  /** Redirects to DEMO_URL — see app/demo/page.tsx for why the hop exists. */
  demo: '/demo',
  howItWorks: '/#how-it-works',
  industriesHash: '/#industries',
  platformHash: '/#platform',
  security: '/#security',
  news: '/#news',
  pricing: '/#pricing',
  book: '/#book',
  faq: '/#faq',
  scanner: '/#scanner',
} as const;

export const INDUSTRY_ROUTES = {
  travelHospitality: '/industries/travel-hospitality',
  retailEcommerce: '/industries/retail-ecommerce',
  financialServices: '/industries/financial-services',
  consumerGoods: '/industries/consumer-goods',
} as const;
